<script>
    import Treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';

    export default {
        mixins: [ Treeselect ],

        inject: {
            elFormItem: {
                default: undefined
            }
        },

        registryName: 'tree-select',

        watch: {
            value: {
                immediate: true,
                handler (v){
                    this.elFormItem && this.elFormItem.$emit('el.form.change', v);

                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/TreeSelect.vue